<template>
  <div class="news-and-footer">
    <div class="page_content">
      <h3>年末年始休業のお知らせ</h3>
      <br>

      <p>
        平素は格別のご高配を賜り、厚く御礼申し上げます。<br>
        誠に勝手ながら下記期間を休業とさせていただきます。
      </p>

      <p>
      -------------------------------------<br>
      2025年12月27日（土）～2026年1月4日（日）<br>
      -------------------------------------<br>
      </p>

      <p>
        年内の受注締め切りは下記の通りです。<br>
        休業期間中お客様には大変ご迷惑をおかけいたしますが、<br>
        ご理解いただきますようお願い申し上げます。
      </p>

      <p>
      -------------------------------------<br>
      ■化粧品・消耗品・美顔器　受注締切■<br>
      12月26日（金）14時締切　当日出荷最終<br>
      -------------------------------------<br>
      </p>

      <p>
      -------------------------------------<br>
      ■ランプ交換受注締切■<br>
      12月25日（木）受注締切、26日（金）出荷最終<br>
      ※12月25日迄に到着するようにお送りください。<br>
      　それ以降の到着分は休み明けの出荷となります事ご了承の程お願いいたします。<br>
      -------------------------------------<br>
      </p>

      <footer2></footer2>
    </div>
  </div>
</template>

<script>
export default {
  name: 'news251226',
  props: {
    largescreen: {
      type: Boolean
    }
  },
  components: {
    footer2: () => import('../components/Footer2.vue'),
  },
}
</script>

<style lang="scss" scoped>
.news-and-footer {
  margin-top: 80px;
}

@media (max-width: 600px) {
  .news-and-footer {
    margin-top: 30px;
  }
}
</style>
